export default __webpack_public_path__ + "static/media/logo.5193d7b2.png";